const config = {
    playerJumpCount : 15,
    playerAnimationSpeed : 0.4,
    playerMovingSpeed: 6,
    playerHeight: 100,
    playerWidth: 73,

    bulletWidth: 7,
    bulletHeight: 6,
    bulletSpeed: 40,
    shotInterval: 500,
    
    enemyAppearanceInterval: 2000,
    enemyInParadiseSpeed: 50,

    gravity: 1,
    speed: 1,
    gameAcceleration: 0.002,
    
    platformSpeed: 2,
    platformWidth: 100,
    platformHeight: 100,

    skyBackgoundSpeed: 0.5,
    smokeBackgoundSpeed: 0.8,
    cityBackgoundSpeed: 0.3,

    standingEnemyHeight: 53,
    standingEnemyWidth: 50,
    standingEnemySpeed: 2,

    flyingEnemyHeight: 35,
    flyingEnemyWidth: 120,
    flyingEnemySpeed: 6,
    flyingEnemyAnimationSpeed: 0.2,

    walkingEnemyWidth: 73,
    walkingEnemyHeight: 100,
    walkingEnemySpeed: 4,
    walkingEnemyAnimationSpeed: 0.3,
};

export default config;
